import CountUp from "countup.js";

export default {
  init() {
    // JavaScript to be fired on the cases page
  },
  finalize() {
      // Load Counters
      var canStart = true;
      function loadCounters() {
          if($('.counters').visible() && canStart) {
              new CountUp("count1", 0, $("#count1").data("val"), 0, 3).start();
              new CountUp("count2", 0, $("#count2").data("val"), 0, 3).start();
              new CountUp("count3", 0, $("#count3").data("val"), 0, 3).start();
              new CountUp("count4", 0, $("#count4").data("val"), 0, 3).start();
              canStart = false;
          }
      }

      function animateCases() {
          $('.case-thumbnail').each(function(i, val) {
              if ($(val).visible(true)) {
                  $(val).addClass("shown");
              }
          });
      }

      setTimeout(function() {
          animateCases();
      }, 500);

      setTimeout(function() {
          loadCounters();
      }, 700);
      $(window).scroll(function() {
          loadCounters();
          animateCases();
      });

      // Comments Carousel
      $('#comments-carousel').on('slide.bs.carousel', function () {
          $(this).find(".active .carousel-caption").addClass("start-opacity");
      });
      $('#comments-carousel').on('slid.bs.carousel', function () {
          $(this).find(".active .carousel-caption").removeClass("start-opacity");
      });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/cases.js